import * as React from 'react';
import { UnifyIcons } from 'src/components/UnifyIcons';
import type { MaterialSymbolsIconProps } from 'src/components/MaterialSymbolsIcon/MaterialSymbolsIcon';
import type { FileLike } from 'src/components/FileUploader/fileModel';

export type FileIconProps = MaterialSymbolsIconProps & {
  fileType: FileLike['type'];
};

/**
 * A utility component that renders a system-default icon based on the provided `fileType` prop value.
 *
 * NOTE: Someday this could be exposed as a public top-level utility fn - but for now, its isolated to FileListItem
 */
export function FileIcon(props: FileIconProps): React.ReactElement {
  const { fileType, ...rest } = props;
  let IconFn: React.FC<MaterialSymbolsIconProps>;

  if (fileType.substring(0, fileType.indexOf('/')) === 'image') {
    IconFn = UnifyIcons.Image;
  } else {
    // Reference: https://github.com/Workiva/content_management_client/blob/199087540db35b113666299be9910aa6b58c0e4f/dart/lib/src/models/entities/entity_subtype.dart
    switch (fileType) {
      case 'application/pdf':
        IconFn = UnifyIcons.PictureAsPdf;
        break;
      case 'application/vnd.ms-excel':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      case 'text/csv':
        IconFn = UnifyIcons.Table;
        break;
      case 'video/quicktime':
      case 'video/mp4':
        IconFn = UnifyIcons.SmartDisplay;
        break;
      // .docx, .esp, .svg, .pptx
      default:
        IconFn = UnifyIcons.Draft;
        break;
    }
  }

  return <IconFn fontSize="small" {...rest} />;
}

export default FileIcon;
